import type { SoldVehicleSearchCriteria } from './types'

type QualificationConfig = {
  requiredSuccesses: number
  totalDurationMs: number
  referenceOffsetRatio: {
    min: number
    max: number
  }
}

type FinalConfig = {
  durationMs: number
  maxHistory: number
}

type ReferencePriceBounds = {
  min: number
  max: number
}

type FetchConfig = {
  batchSize: number
  minBuffer: number
  criteria: SoldVehicleSearchCriteria
}

type StorageConfig = {
  key: string
}

export type JusteEnchereConfig = {
  qualification: QualificationConfig
  final: FinalConfig
  priceBounds: ReferencePriceBounds
  fetch: FetchConfig
  storage: StorageConfig
}

export const createDefaultCriteria = (): SoldVehicleSearchCriteria => ({
  limit: 100,
  must: [
    {
      key: 'ErpResult.EventDate',
      radius: 12,
      value: new Date().toISOString(),
    },
  ],
})

export const JUSTE_ENCHERE_CONFIG: JusteEnchereConfig = {
  qualification: {
    requiredSuccesses: 8,
    totalDurationMs: 30_000,
    referenceOffsetRatio: {
      min: 0.05,
      max: 0.35,
    },
  },
  final: {
    durationMs: 45_000,
    maxHistory: 5,
  },
  priceBounds: {
    min: 0,
    max: 250_000,
  },
  fetch: {
    batchSize: 30,
    minBuffer: 5,
    criteria: createDefaultCriteria(),
  },
  storage: {
    key: 'fun.justeEnchere.stats.v1',
  },
}

export const resolveConfig = (overrides?: Partial<JusteEnchereConfig>): JusteEnchereConfig => ({
  ...JUSTE_ENCHERE_CONFIG,
  ...overrides,
  qualification: {
    ...JUSTE_ENCHERE_CONFIG.qualification,
    ...overrides?.qualification,
  },
  final: {
    ...JUSTE_ENCHERE_CONFIG.final,
    ...overrides?.final,
  },
  priceBounds: {
    ...JUSTE_ENCHERE_CONFIG.priceBounds,
    ...overrides?.priceBounds,
  },
  fetch: {
    ...JUSTE_ENCHERE_CONFIG.fetch,
    ...overrides?.fetch,
    criteria: {
      ...createDefaultCriteria(),
      ...overrides?.fetch?.criteria,
    },
  },
  storage: {
    ...JUSTE_ENCHERE_CONFIG.storage,
    ...overrides?.storage,
  },
})
